const completion = {
  header: 'Vielen Dank für Ihre Bestellung!',
  lead: 'Ihre Bestellung ist bei uns eingegangen und wird schnellstmöglich bearbeitet. In Kürze erhalten Sie eine Bestellbestätigung an die von Ihnen angegebene E-Mail-Adresse.',
  msg: 'Sollten Sie Fragen zu Ihrer Bestellung haben, können Sie gerne Kontakt mit uns aufnehmen. Wir helfen Ihnen gerne weiter!',
  btnReload: {
    text: 'Seite neu laden',
    textShort: 'Neu laden',
    icon: 'arrow-clockwise'
  },
  btnShop: {
    text: 'zum Shop',
    icon: 'house-door-fill'
  }
}

export default {
  completion
}
